var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUneditableItems = function SvgUneditableItems(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2350_17914)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 87,
    r: 5,
    transform: "rotate(-180 45 87)",
    fill: "#F7E1F4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 55,
    r: 18,
    transform: "rotate(-180 89 55)",
    fill: "#DFF2FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2350_17914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94 63.3171C94 60.9328 92.0672 59 89.6829 59H65.3171C62.9328 59 61 60.9328 61 63.3171V87.6827C61 90.0672 62.9328 92 65.3171 92H89.6827C92.0672 92 94 90.0672 94 87.6829V63.3171ZM68.4074 85.9468C67.6924 86.1386 67.0381 85.4843 67.2299 84.7693L68.4156 80.3498L72.8268 84.7609L68.4074 85.9468ZM87.4578 69.8746L74.4026 82.93L70.0117 78.539L83.0669 65.4838C83.6861 64.8646 84.6897 64.8646 85.3089 65.4838L87.4578 67.6327C88.0769 68.2517 88.0769 69.2554 87.4578 69.8746Z",
    fill: "url(#paint0_linear_2350_17914)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2350_17914",
    x: 0,
    y: 0,
    width: 106,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.368627 0 0 0 0 0.427451 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2350_17914"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2350_17914",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2350_17914",
    x1: 94,
    y1: 59,
    x2: 61,
    y2: 59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2350_17914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white",
    transform: "translate(61 59)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUneditableItems);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/uneditableItems.a49759bf6206a684844f74f36c3821d1.svg";